import React, { useState, useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Button, Tooltip, Grid } from "antd"
import {
  CaretDownFilled,
  CaretUpFilled,
} from "@ant-design/icons"
import { ReactComponent as PlayerUpper } from "../../assets/PlayerUpper.svg"
import { ReactComponent as PlayerLower } from "../../assets/PlayerLower.svg"
import { ReactComponent as Play } from "../../assets/Play.svg";
import { ReactComponent as Pause } from "../../assets/Pause.svg";
import { ReactComponent as RePlay } from "../../assets/Replay.svg";
import { ReactComponent as One } from "../../assets/One.svg";
import { ReactComponent as Two } from "../../assets/Two.svg";
import { ReactComponent as Three } from "../../assets/Three.svg";
import { ReactComponent as Four } from "../../assets/Four.svg";
import { ReactComponent as Five } from "../../assets/Five.svg";

import { ReactComponent as SpeedOne } from "../../assets/SpeedOne.svg";
import { ReactComponent as SpeedTwo } from "../../assets/SpeedTwo.svg";
import { ReactComponent as SpeedThree } from "../../assets/SpeedThree.svg";
import { setLowerModelIndex, setUpperModelIndex } from '../../redux/modelSlice';
import { primaryColor } from "colors-config"



const Player = () => {
  const iprDetails = useSelector((state) => state.model.iprDetails);
  const [activeUpperAligners,setActiveUpperAligners] = useState([])
  const [activeLowerAligners,setActiveLowerAligners] = useState([])
  const [playerSpeed,setPlayerSpeed] = useState(400)
  const attachmentDetails = useSelector(
    (state) => state.model.attachtmentDetails
  );
  const [isPlaying, setIsPlaying] = useState(false)
  const [loopPlay, setLoopPlay] = useState(false)
  const dispatch = useDispatch();
  const { 
    noOfUpperAligners, 
    noOfLowerAligners, 
    lowerModelIndex, 
    upperModelIndex, 
    modelsRemaining,
    lowerAlignerFiles,
    upperAlignerFiles
  } = useSelector((state) => state.model)


  const zeroStage = () => {
    if((lowerAlignerFiles.length + upperAlignerFiles.length) > (noOfUpperAligners + noOfLowerAligners)){
      return 0;
    }
    return 1;
  }


  const upperArray = Array.from({ length: zeroStage() ? noOfUpperAligners :(noOfUpperAligners + 1)  }, (_, i) => i + zeroStage())
  const lowerArray = Array.from({ length: zeroStage() ? noOfLowerAligners : (noOfLowerAligners + 1)}, (_, i) => i + zeroStage())
  const scrollContainerRef = useRef(null)
  const lastClickedRef = useRef("upper");

  useEffect(() => {
    if (iprDetails?.length > 0 || attachmentDetails?.length > 0) {
  const activeIprCountsUpper = iprDetails?.filter((ipr) => ipr.jawType === "upper").map((obj) => obj.aligner_count) || []
  const upperAttachmentCounts = attachmentDetails?.filter((ipr) => ipr.jawType === "upper").map((obj) => obj.aligner_count) || []
  setActiveUpperAligners([...activeIprCountsUpper, ...upperAttachmentCounts])
  // const activeLowerCounts = iprDetails?.filter((ipr) => ipr.jawType === "lower").map((obj) => obj.aligner_count)
  const activeIprCountsLower = iprDetails?.filter((ipr) => ipr.jawType === "lower").map((obj) => obj.aligner_count) || []
  const lowerAttachmentCounts = attachmentDetails?.filter((ipr) => ipr.jawType === "lower").map((obj) => obj.aligner_count) || []
  setActiveLowerAligners([...activeIprCountsLower, ...lowerAttachmentCounts])
  // setActiveLowerAligners(activeLowerCounts)
 }
  }, [iprDetails, attachmentDetails])


  // useEffect(() => {
  //   let finalCounts = [];
  //   // console.log("iprDetailsiprDetails", iprDetails)
  //   // console.log("attachmentDetailsattachmentDetails", attachmentDetails)
  //   const iprCounts = iprDetails.map((ipr) => ipr.aligner_count);
  //   // console.log("iprCountsiprCounts", iprCounts)
  //   const attachmentCounts = attachmentDetails.map((obj) => obj.aligner_count);
  //   // console.log("attachmentCountsattachmentCounts", attachmentCounts)
  //   finalCounts = [...iprCounts, ...attachmentCounts];
  //   //  console.log("finalCountsfinalCounts", finalCounts)
  //   setTableData(finalCounts);
  // }, [iprDetails, attachmentDetails]);
  

  const handlePlay = () => {
    setIsPlaying(!isPlaying)
    setLoopPlay(false)
    if ((lowerModelIndex === noOfLowerAligners && upperModelIndex === noOfUpperAligners)) {
      dispatch(setLowerModelIndex(zeroStage()))
      dispatch(setUpperModelIndex(zeroStage()))
    }
    // Add logic for playing/pausing the animation
  }

  const handleUpperStageClick = (stage) => {
    lastClickedRef.current = "upper";
    if(stage <= noOfUpperAligners){
      dispatch(setUpperModelIndex(stage))
    }
    // Add logic for changing the stage
  }

  const handleLowerStageClick = (stage) => {
    lastClickedRef.current = "lower";
    if(stage <= noOfLowerAligners){
      dispatch(setLowerModelIndex(stage))
    }
    // Add logic for changing the stage
  }

  const handleNext = () => {
    if ((lowerModelIndex === noOfLowerAligners && upperModelIndex === noOfUpperAligners) && isPlaying) {
      if(loopPlay){
        dispatch(setLowerModelIndex(zeroStage()))
        dispatch(setUpperModelIndex(zeroStage()))
      } else {
        setIsPlaying(!isPlaying)
      }
    } else {
      const lowerStage = lowerModelIndex < noOfLowerAligners ? lowerModelIndex + 1 : noOfLowerAligners
      const upperStage = upperModelIndex < noOfUpperAligners ? upperModelIndex + 1 : noOfUpperAligners
      if( lowerModelIndex < noOfLowerAligners){
        lastClickedRef.current = "lower"
      } else {
        lastClickedRef.current = "upper"
      }
      dispatch(setLowerModelIndex(lowerStage));
      dispatch(setUpperModelIndex(upperStage));
    } 

  };

  const handlePrevious = () => {
    if(lowerModelIndex === zeroStage()) {
      dispatch(setLowerModelIndex(zeroStage()))
    } else {
      dispatch(setLowerModelIndex(lowerModelIndex > 0 ? lowerModelIndex - 1 : zeroStage()));
    }

    if(upperModelIndex === zeroStage()){
      dispatch(setUpperModelIndex(zeroStage()))
    } else {
    dispatch(setUpperModelIndex(upperModelIndex > 0 ? upperModelIndex - 1 : zeroStage()));
    }
  };

  const handleReplay = () => {
    dispatch(setLowerModelIndex(zeroStage()))
    dispatch(setUpperModelIndex(zeroStage()))
    setIsPlaying(true)
    setLoopPlay(true)
  }

  const btnsRowRef = useRef(null);
  // const btnsRowRefLower = useRef(null);
  const [lineWidth, setLineWidth] = useState("100%");
  const [lineWidthLower, setLineWidthLower] = useState("100%");


  useEffect(() => {
    if (btnsRowRef.current) {
      setLineWidth(`${btnsRowRef.current.scrollWidth}px`); // Get actual button row width
    }
  }, [upperArray.length]);


  // useEffect(() => {
  //   if (btnsRowRefLower.current) {
  //     setLineWidthLower(`${btnsRowRefLower.current.scrollWidth - 20}px`); // Get actual button row width
  //   }
  // }, [lowerArray.length]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (btnsRowRef.current) {
        setLineWidthLower(`${btnsRowRef.current.scrollWidth}px`);
      }
    }, 0);
  
    return () => clearTimeout(timeout);
  }, [lowerArray, lowerModelIndex, activeLowerAligners]);



  
//   const getMultiplier = () => {
//     const screens = useBreakpoint();
//     console.log("screeens", screens);
//     if (screens.xxl) {
//         return 58; 
//     }
//     else if (screens.xl) {
//       return 50;
//     } else if (screens.sm || screens.md) {
//       return 45;
//     } else {
//       return 40;
//     }
//   };
  // useEffect(() => {
  //   const scrollToActiveButton = () => {
  //     if (scrollContainerRef.current) {
  //       const activeUpperButton = scrollContainerRef.current.querySelector(".player-btns-container")
  //       const activeLowerButton = scrollContainerRef.current.querySelector(".player-btns-container")
  //       if (activeUpperButton) {
  //         activeUpperButton.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  //       } else if (activeLowerButton) {
  //         activeLowerButton.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  //       }
  //     }
  //   }

  //   scrollToActiveButton()
  // }, [upperModelIndex, lowerModelIndex])

  useEffect(() => {
    const scrollToActiveButton = () => {
      if (scrollContainerRef.current) {
        let targetButton = null;
      
        if (lastClickedRef.current === "upper") {
          targetButton = scrollContainerRef.current.querySelector(
            ".btns-row-upper .circle-btn.active"
          );
        } else {
          targetButton = scrollContainerRef.current.querySelector(
            ".btns-row-lower .circle-btn.active"
          );
        }
  
        if (targetButton) {
          targetButton.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }
    };
  
    scrollToActiveButton();
  }, [upperModelIndex, lowerModelIndex]);
  
  

  useEffect(() => {
    const handleResize = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          left: (upperModelIndex - 1) * 56,
          behavior: "smooth",
        });
      }
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [upperModelIndex]);

  useEffect(() => {
    if (!isPlaying) return;

    const interval = setInterval(() => {
      handleNext();
    }, playerSpeed);

    return () => clearInterval(interval);
  }, [isPlaying, playerSpeed, handleNext]);


  const handleSpeedChange = (speed) => {
    setPlayerSpeed(speed);
  };


  if(modelsRemaining > 0 ){
    return ''
  } else {
    return (
      <div className="player-container">
        <div className="aligner-info">
          <div className="player-col-one">
            <div className="circle">{noOfUpperAligners}</div>
            <p>Upper</p>
            <PlayerUpper />
          </div>
          <div className="player-col-one">
            <div className="circle">{noOfLowerAligners}</div>
            <p>Lower</p>
            <PlayerLower />
          </div>
        </div>

        <div className="player-main">
          <div className="player-controls-container">
            <div className="player-controls">
              <Tooltip title="First Stage">
                <Button
                  onClick={() => {
                    dispatch(setLowerModelIndex(zeroStage()));
                    dispatch(setUpperModelIndex(zeroStage()));
                  }}
                  type="text"
                  icon={<Five />}
                  className="control-button"
                />
              </Tooltip>
              <Tooltip title="Backward">
                <Button
                  type="text"
                  onClick={() => {
                    handlePrevious();
                  }}
                  icon={<Four />}
                  className="control-button"
                />
              </Tooltip>
              <Tooltip title={isPlaying ? "Pause" : "Play"}>
                <Button
                  type="text"
                  icon={isPlaying ? <Pause /> : <Play />}
                  onClick={handlePlay}
                  className="play-button"
                />
              </Tooltip>
              <Tooltip title="Forward">
                <Button
                  type="text"
                  onClick={() => {
                    handleNext();
                  }}
                  icon={<One />}
                  className="control-button"
                />
              </Tooltip>
              <Tooltip title="Last Stage">
                <Button
                  onClick={() => {
                    dispatch(setLowerModelIndex(noOfLowerAligners));
                    dispatch(setUpperModelIndex(noOfUpperAligners));
                  }}
                  type="text"
                  icon={<Three />}
                  className="control-button"
                />
              </Tooltip>
            </div>
          </div>

          <div className="player-btns-container" ref={scrollContainerRef}>
            <div className="btns-row btns-row-upper" ref={btnsRowRef}>
              <div className="line" style={{ width: lineWidth }} />
              {/* <div className="line" style={{ width: `${noOfUpperAligners * 56 }px` }}/> */}
              {upperArray.map((i) => (
                <div key={i} className="button-wrapper">
                  {upperModelIndex === i && (
                    <CaretDownFilled className="stage-indicator" />
                  )}
                  <Button
                    type="text"
                    shape="circle"
                    className={`circle-btn ${
                      upperModelIndex === i ? "active" : ""
                    }`}
                    onClick={() => handleUpperStageClick(i)}
                    style={{
                      backgroundColor: activeUpperAligners.includes(i)
                        ? primaryColor
                        : "white",
                        color: activeUpperAligners.includes(i)
                        ? "#ffff"
                        : "black",
                    }}
                  >
                    {i}
                  </Button>
                </div>
              ))}
            </div>
            <div className="btns-row btns-row-lower">
              <div className="line" style={{ width: lineWidthLower }} />
              {lowerArray.map((i) => (
                <div key={i} className="button-wrapper">
                  {lowerModelIndex === i && (
                    <CaretUpFilled className="stage-indicator-bottom" />
                  )}
                  <Button
                    type="text"
                    shape="circle"
                    className={`circle-btn ${
                      lowerModelIndex === i ? "active" : ""
                    }`}
                    onClick={() => handleLowerStageClick(i)}
                    style={{
                      backgroundColor: activeLowerAligners.includes(i)
                        ? primaryColor
                        : "white",
                        color: activeLowerAligners.includes(i)
                        ? "#ffff"
                        : "black",
                    }}
                  >
                    {i}
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{display:"flex", alignItems:"center", flexDirection:"column", gap:"3px"}}>
        <div className="replay-icon">
          <Tooltip title="Replay">
            <Button
              style={{ visibility: !isPlaying ? "visible" : "hidden" }}
              onClick={() => handleReplay()}
              type="text"
              icon={<RePlay />}
              className="replay-button"
            />
          </Tooltip>         
        </div>
        <div className="replay-icon">
        <Tooltip title={`Playback Speed ${playerSpeed === 1000 ? "1.0" : playerSpeed === 700 ? "1.5" : "2.0"}x`}  placement="topLeft" >
        {playerSpeed === 1000 && (
        <SpeedOne
          onClick={() => handleSpeedChange(400)}
          style={{ fontSize: "14px", cursor: "pointer" }}
        />
      )}
      {playerSpeed === 700 && (
        <SpeedTwo
          onClick={() => handleSpeedChange(1000)}
          style={{ fontSize: "14px", cursor: "pointer" }}
        />
      )}
      {playerSpeed === 400 && (
        <SpeedThree
          onClick={() => handleSpeedChange(700)}
          style={{ fontSize: "14px", cursor: "pointer" }}
        />
      )}
          </Tooltip>
   
        </div>
        </div>

  
      </div>
    );
  }
  
}

export default Player













